import {PossessedStatics} from "../config/PossessedStatics";
import {gsap, TimelineLite} from "gsap";
import {Possessed} from "../Possessed";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {PossessedWinConfig} from "../config/PossessedWinConfig";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Graphics} from "pixi.js";

interface WinAnimation {
    spine:PIXI.spine.Spine|undefined;
    isWinToggleAnim:boolean;
}

export class PossessedWinFireView extends PIXI.Container {

    private animations:WinAnimation[][] = [[], [], [], [], []];

    constructor() {
        super();
        this.name = "WinFireView";
        this.position.y = 152;
        for(let i = 0; i <  PossessedStatics.NUMBER_OF_REELS; i++) {
            for(let j = 0; j < PossessedStatics.NUMBER_OF_ROWS[i]; j++) {
                this.animations[i][j] = {
                    spine: undefined,
                    isWinToggleAnim: false,
                }
            }
        }
    }

    private getWinFireSpine(reelID:number, reelPos:number):PIXI.spine.Spine {
        const anim = this.animations[reelID][reelPos];
        if(!anim.spine  || anim.isWinToggleAnim) {
            anim.spine = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.WIN_FIRE));
            anim.isWinToggleAnim = false;
            if(!this.children.find(c => c == anim.spine)) this.addChild(anim.spine);
        }
        return anim.spine;
    }

    private getWinToggleAnim(reelID:number, reelPos:number) {
        const anim = this.animations[reelID][reelPos];
        if(!anim.spine || (anim.spine && !anim.isWinToggleAnim)) {
            anim.spine = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.SYMBOL_WIN_TOGGLE_FIRE))
            anim.isWinToggleAnim = true;
            if(!this.children.find(c => c == anim.spine)) this.addChild(anim.spine);
        }
        anim.spine.visible = false;
        return anim.spine;
    }
    public getIndiSymWinAmtWaysTl(winAmt: number, winWays: number, reelId: number, reelPos: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            win = new PIXI.BitmapText(Possessed.apiPlugin.currency.formatValue(winAmt), {
                fontName: PossessedGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 40,
                tint: 0xffffff
            }),
            ways: PIXI.Text = new PIXI.Text(winWays + " " + Possessed.apiPlugin.translations.translate(winWays > 1 ? "Ways" : "Way"), new PIXI.TextStyle({
                fill: `#ff0000`,
                fillGradientStops: [10],
                fontSize: 30,
                fontWeight: `bolder`,
                letterSpacing: 1,
                lineJoin: `round`,
                miterLimit: 0,
                stroke: `#030303`,
                strokeThickness: 8,
            })),
            cont: PIXI.Container = new PIXI.Container();

        while (win.width > PossessedStatics.SYMBOL_WIDTH) {
            win.fontSize--;
        }
        while (ways.width > PossessedStatics.SYMBOL_WIDTH) {
            ways.style.fontSize--;
        }
        ways.position.y=44;
        win.pivot.set(win.width / 2, win.height / 2);
        ways.pivot.set(ways.width / 2, ways.height / 2);
        cont.addChild(win, ways);
        cont.position.set(
            reelId *  PossessedStatics.SYMBOL_WIDTH + PossessedStatics.SYMBOL_WIDTH/2,
            PossessedStatics.SYMBOL_HEIGHT*reelPos-20
        );
        if(reelId == 0 || reelId == 4) {
            cont.position.y += PossessedStatics.SYMBOL_HEIGHT*2;
        }
        cont.addChild(ways);
        tl.add(() => {
            Possessed.reelView.winFireView.addChild(cont);
            // NolimitApplication.getLayerByName(Possessed.reelView.name)?.addChild(cont);
        })
        tl.to(cont, {duration: 1});
        tl.add(() => {
            Possessed.reelView.winFireView.removeChild(cont);
            // NolimitApplication.getLayerByName(Possessed.reelView.name)?.removeChild(cont);
        })
        return tl;
    }
    public getSymIndiWinAnim(reelID:number,reelPosition:number): gsap.core.Timeline {
        const tl = gsap.timeline(),
            graphics = new Graphics();
        graphics.beginFill(0xffffff, 1);
        graphics.drawRect(0, 0, PossessedStatics.SYMBOL_WIDTH , PossessedStatics.SYMBOL_HEIGHT);
        graphics.endFill();
        // graphics.tint= 0x0080ff;
        graphics.pivot.set(graphics.width / 2, graphics.height / 2);
        graphics.position.set(
            reelID *  PossessedStatics.SYMBOL_WIDTH + PossessedStatics.SYMBOL_WIDTH/2,
            PossessedStatics.SYMBOL_HEIGHT*reelPosition
        );
        if(reelID == 0 || reelID == 4) {
            graphics.position.y += PossessedStatics.SYMBOL_HEIGHT*2;
        };
        graphics.alpha = 0;
        tl.add(() => {
            this.addChild(graphics);
        });
        tl.to(graphics, 0.3, {alpha: 0.5});
        tl.to(graphics, 0.3, {alpha: 0});
        tl.add(() => {
            this.removeChild(graphics);
        })
        return tl;
    }

    playWinFireAt(winRatio:number, reelID:number, reelPosition:number):gsap.core.Timeline {
        let spine = this.getWinFireSpine(reelID, reelPosition);
        const tl = gsap.timeline();
        tl.add(() => {
            SpineGSAPWrapper.resetSpineState(spine);
            spine.position.set(
                reelID *  PossessedStatics.SYMBOL_WIDTH + PossessedStatics.SYMBOL_WIDTH/2,
                PossessedStatics.SYMBOL_HEIGHT*reelPosition
            );
            if(reelID == 0 || reelID == 4) {
                spine.position.y += PossessedStatics.SYMBOL_HEIGHT*2;
            }
        })
        let anim = "smallW";
        const winConf = PossessedWinConfig.getWinConfig(winRatio);
        if(winConf.winLevel >= 3) {
            anim = "largeW";
        } else if(winConf.winLevel >= 2) {
            anim = "midW";
        }
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(spine, 0, anim, 1, 0, true));
        tl.add(() => {
            spine.visible = false;
        })
        return tl;
    }

    public playWinToggleAt(reelID:number, reelPos:number):gsap.core.Timeline {
        let spine = this.getWinToggleAnim(reelID, reelPos);
        const tl = gsap.timeline();
        tl.add(() => {
            SpineGSAPWrapper.resetSpineState(spine);
            spine.position.set(
                reelID *  PossessedStatics.SYMBOL_WIDTH + PossessedStatics.SYMBOL_WIDTH/2,
                PossessedStatics.SYMBOL_HEIGHT*reelPos
            );
            if(reelID == 0 || reelID == 4) {
                spine.position.y += PossessedStatics.SYMBOL_HEIGHT*2;
            }
        });
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(spine, 0, "indivadualWin", 1, 0, true));
        tl.add(() => {
            spine.visible = false;
        })
        return tl;
    }

    public clearAllSpines() {
        this.animations.forEach(reel => reel.forEach(anim => {
            if(anim.spine) {
                SpineGSAPWrapper.resetSpineState(anim.spine);
                anim.spine.visible = false;
            }
        }))
    }
}